import React, { Fragment, Component } from "react";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { handleModalState } from "common-components/Modal/actions/handleModalState";
import { setA11yContent } from "../../NavigationHelper/actions";
import { requestDelete, handleDeleteRadioChange } from "../actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { media } from "utils/style";

import Header from "common-components/Header";
import Container from "common-components/Container";
import Button from "common-components/Buttons";
import { TitleLockup } from "@vds/type-lockups";
import { RadioButton } from "@vds/radio-buttons";
import { Body } from "@vds/typography"
import DeleteReview from "./DeleteReview";
import Modal from "common-components/Modal/Modal";

class DeleteLineSelection extends Component {
  state = {
    isReturnDelete: false,
    visibleModal: false
  };
  handleModalPopup = () => { this.setState({ visibleModal: false }); };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "delete_selection", "sc_pagetitle")) {
      this.props.setA11yContent("Delete line selection", this.props.pageContent.delete_selection.sc_pagetitle);
    }

    const { hasDeleted, deleteRequestType } = this.props;

    if (hasDeleted === "Y" && deleteRequestType === "self" && !window.reactGlobals.isSingleLineAcct) {
      this.setState({ isReturnDelete: true });
      this.props.handleDeleteRadioChange("all");
    }
  }

  render() {
    const pageContent = this.props.pageContent.delete_selection;

    if (pageContent === undefined) {
      return <Redirect to="/privacy/secure/your-data" />;
    }
    return (
      <Fragment>
        <Container noTabletPadding>
          <div style={{ maxWidth: "596px" }}>
            <TitleLockup 
              data={{
                  title:{
                    size: 'titleLarge',
                    children: pageContent.section_title
                  },
                  subtitle:{
                    size: 'bodyLarge',
                    children:<p style={{ margin: "30px 0 14px 0" }}>{convertStringToElements(pageContent.section_description)}</p>
                  }

              }}
            />
            <Div>{convertStringToElements(pageContent.richText[0].description)}</Div>
            <fieldset style={{ marginBottom: "30px" }}>
              <Body size='medium' bold={false}>Select whose information you want to delete</Body>
              {pageContent.genericList[0].list.map(item => (
                <div key={item.jsonKey} style={{ margin: "10px 0 0 17px" }}>
                <RadioButton
                  name="deleteLineSelection"
                  value={item.jsonValue}
                  children={<span style={{marginLeft:"-28px"}}>{item.jsonKey}</span>}
                  onChange={() => this.props.handleDeleteRadioChange(item.jsonValue)}
                  selected={item.jsonValue === this.props.deleteLineSelection}
                  disabled={item.jsonValue === "self" && this.state.isReturnDelete}
                />
                 
                </div>
              ))}
            </fieldset>
            <ButtonContainer>
            <Button
              onClick={() => this.setState({ visibleModal: true })}
              background={pageContent.buttons[0].type}
            >
              {pageContent.buttons[0].text}
            </Button>
            <Button
              role="link"
              onClick={() => this.props.history.goBack()}
              background={pageContent.buttons[1].type}
            >
              {pageContent.buttons[1].text}
            </Button>
            </ButtonContainer>
          </div>
        </Container>
        <Modal id="modalStyle" visibleModal={this.state.visibleModal} closeModal={this.handleModalPopup}>
          <DeleteReview closeModal={this.handleModalPopup} />
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  modalState: { showModal },
  loadingAndErrorState: { error, loading },
  downloadAndDelete: { deleteRequestType, hasDeleted },
  deleteLineSelection,
  pageContent
}) => ({
  showModal,
  loading,
  error,
  pageContent,
  deleteRequestType,
  hasDeleted,
  deleteLineSelection
});

export default connect(
  mapStateToProps,
  { handleModalState, requestDelete, setA11yContent, handleDeleteRadioChange }
)(DeleteLineSelection);

const Div = styled.div`
  p {
    margin: 10px 0;
    font-size: 12px;
    line-height: 14px;
    max-width: 500px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 60px;
  display: flex;
  button,
  a {
    width: 172px;
  }
  ${media.mobile`
    flex-direction: column;    
  `}
`;
